module.exports = __webpack_public_path__ + "img/astronomy-atmosphere-earth-exploration-220201.f5b3d660.jpg";